import React, { Component } from "react";
import { Editor as TinyMCE } from "@tinymce/tinymce-react";
import Functions from "../../src/functions";

class Editor extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    this.editable = this.editable.bind(this);
    this.nonEditable = this.nonEditable.bind(this);
    this.customUI = this.customUI.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);

    this.editorRef = React.createRef();

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = "";
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    this.state = {
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
    };
  }

  componentDidMount() {
    this.setState({
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      loaded: true,
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      fullHTML: this.props.property?.configuration?.fullHTML,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  handleEditorChange = (content, editor) => {
    editor.save();
  };

  editable() {
    let fullpage = "";
    fullpage = this.state.fullHTML ? " fullpage " : "";

    let control = (
      <div className="pb-5">
        <TinyMCE
          initialValue={this.state.defaultValue}
          ref={this.editorRef}
          init={{
            entity_encoding: "raw",
            height: 300,
            menubar: false,
            valid_elements: "*[*]",
            extended_valid_elements: "*[*]",
            inline_styles: true,
            paste_data_images: true,
            relative_urls: false,
            convert_urls: false,
            remove_script_host: false,
            // mceInsertRawHTML: true,
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code",
              "insertdatetime media table paste code help wordcount" +
                fullpage +
                " fullscreen",
            ],
            // plugins: ["code", "fullpage", "fullscreen"],
            toolbar:
              "undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help  | code | " +
              fullpage +
              " | fullscreen ",
          }}
          onEditorChange={this.handleEditorChange}
          textareaName={this.state.name}
          {...this.state.attributes}
          plugins="lists code"
        />
        {/* <input
          type="hidden"
          name={this.state.name}
          value={this.state.defaultValue}
        ></input> */}
      </div>
    );
    return this.customUI(control);
  }

  nonEditable() {
    let control = Functions.parse(this.state.defaultValue);

    return this.customUI(control);
  }

  render() {
    if (this.state.loaded) {
      let control = this.state.editable ? this.editable() : this.nonEditable();

      return control;
    }
    return "";
  }
}

export default Editor;
